export default __webpack_public_path__ + "static/media/ratings-star.defff666.svg";